const apiBaseUrl = process.env.REACT_APP_API_URL;

export const workflowIdEndpoint = `${apiBaseUrl}workflowid`;
export const signupEndpoint = `${apiBaseUrl}signupuser`;
export const verificationCodeEndpoint = `${apiBaseUrl}verify`;
export const countriesEndpoint = `${apiBaseUrl}countries`;
export const usStatesEndpoint = `${apiBaseUrl}usstates`;
export const caStatesEndpoint = `${apiBaseUrl}castates`;
export const invitationInformationEndpoint = `${apiBaseUrl}invitationinfo`;
export const invitationChoiceEndpoint = `${apiBaseUrl}invitationchoice`;
export const existingPrimaryInvitationInformationEndpoint = `${apiBaseUrl}existingprimaryinvitationinfo`;
export const resetPasswordInitiateEndpoint = `${apiBaseUrl}resetPasswordInitiate`;
export const changePasswordEndpoint = `${apiBaseUrl}changePassword`;
